import React, { useEffect, useState } from 'react';

import { useRoot } from '../../../context/RootProvider';
import { Typography } from '../../../designComponents';
import CompanyDetails from './CompanyDetails';
import Congratulations from './Congratulations';
import ContactInformation from './ContactInformation';
import { OnboardingFormsContainer } from './onboardingForms.style';
import PersonalInformation from './PersonalInformation';
import UploadProfileImage from './UploadProfileImage';

export type ActiveComponentType = {
  initialState: Partial<InitialStateType>;
  setInitialState: React.Dispatch<
  React.SetStateAction<Partial<InitialStateType>>
  >;
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>;
};

const stepToComponentMap: Record<
string,
(props: ActiveComponentType) => JSX.Element
> = {
  step_1: PersonalInformation,
  step_2: UploadProfileImage,
  step_3: ContactInformation,
  step_4: CompanyDetails,
  // step_5: PaymentMethod,
  step_5: Congratulations,
};

type InitialStateType = {
  userType: string;
  fullName: string;
  password: string;
  emailAddress: string;
  mobileNumber: string;
  address1: string;
  address2: string;
  city: string;
  country: string;
  postalCode: string;
  companyName: string;
  cardNumber: string;
  expirationDate: string;
  cvc: string;
  onboardingStep: number;
  skip: boolean;
  paymentMethod: string;
};

type Props = {
  currentStep: number;
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>;
};

const OnBoardingForms = ({ currentStep, setCurrentStep }: Props) => {
  const { auth } = useRoot();
  const [initialState, setInitialState] = useState<Partial<InitialStateType>>({
    userType: '',
    fullName: '',

    emailAddress: '',
    mobileNumber: '',
    address1: '',
    address2: '',
    city: '',
    country: '',
    postalCode: '',
    companyName: '',
    cardNumber: '',
    expirationDate: '',
    cvc: '',
    onboardingStep: 1,
    paymentMethod: '',
  });
  const ActiveComponent = stepToComponentMap['step_' + currentStep];

  useEffect(() => {
    setInitialState({
      userType: auth?.role || '',
      fullName: auth?.fullName || '',
      emailAddress: auth?.emailAddress || '',
      mobileNumber: auth?.mobileNumber || '',
      address1: auth?.contactInfo?.address1 || '',
      address2: auth?.contactInfo?.address2 || '',
      city: auth?.contactInfo?.city || '',
      country: auth?.contactInfo?.country || '',
      postalCode: auth?.contactInfo?.postalCode || '',
      companyName: auth?.companyDetails?.companyName || '',
      cardNumber: '',
      expirationDate: '',
      cvc: '',
      onboardingStep: 1,
    });
  }, [auth]);

  if (!ActiveComponent) {
    return (
      <OnboardingFormsContainer>
        <Typography variant="heading">Invalid onboarding step</Typography>
      </OnboardingFormsContainer>
    );
  }
  return (
    <OnboardingFormsContainer>
      <ActiveComponent
        initialState={initialState}
        setInitialState={setInitialState}
        setCurrentStep={setCurrentStep}
      />
    </OnboardingFormsContainer>
  );
};

export default OnBoardingForms;
